module.exports = __webpack_public_path__ + "static/media/Woman_On_Stool.5dd759ac.png";